(ns manage.ad-variant.creation.product-strategy.core)

(defn ad-format->product-strategy-id [{:keys [dynamic-content]}]
  (some (fn [[_ v]] (:product-strategy-id v)) (:product-strategy dynamic-content)))

(defn ad-format->product-collection-placeholder [{:keys [current-revision]}]
  (some (fn [[placeholder-name {:keys [type intent items_required]}]]
          (when (and (= "collection" type)
                     (= "product" intent))
            {:placeholder-name placeholder-name
             :items-required items_required}))
        (:placeholders current-revision)))
